<template>
  <SrpModal v-model:isVisible="_isVisible" size="small">
    <template #content>
      <!-- Confirm deletion modal -->
      <div class="confirm-deletion-modal">
        <div
          :class="{
            'standard-page-header': true,
            'standard-page-header--no-bottom-line': true,
            'confirm-deletion-modal__header': true,
          }"
        >
          <h2 class="global-h2 standard-page-header__title">
            {{ props.fileIdsToDelete.length === 1 ? "Do you really want to permanently delete this photo?" : `Do you really want to permanently delete these ${props.fileIdsToDelete.length} photos?` }}
          </h2>
        </div>
      </div>
      <!-- / Confirm deletion modal -->
    </template>

    <template #footer="{ closeModal }">
      <SrpButton @click="closeModal" color="gray" fill="outlined" :isDisabled="isDeleting">Cancel</SrpButton>

      <SrpButton
        color="red"
        :isDisabled="isDeleting"
        @click="
          async () => {
            await deletePhotoAndVideos();
            closeModal();
            emit('deletionCompleted');
          }
        "
      >
        <template #icon>
          <LoadingIcon v-if="isDeleting" :size="19" />
          <IconEmbedded v-else name="trashcan-alt_2-5" :size="19" />
        </template>
        Delete
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref } from "vue";
import PhotoGalleryV2Repo from "@repos/PhotoGalleryV2Repo";
import { PhotoGallerySource } from "@contracts/photosPageData";

// Components
import SrpModal from "@components/ui/SrpModal.vue";
import SrpButton from "@components/ui/SrpButton.vue";
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

const props = withDefaults(
  defineProps<{
    customerId: string;
    fileIdsToDelete: Array<string>;
    currentOperationSource?: PhotoGallerySource | null;
  }>(),
  {
    customerId: "",
    fileIdsToDelete: () => [],
    currentOperationSource: null,
  }
);

const emit = defineEmits<{
  (e: "deletionCompleted"): void;
}>();

// Private isVisible ==========================================================
const _isVisible = ref<boolean>(false);

// Delete photos & videos =====================================================
const isDeleting = ref<boolean>(false);

async function deletePhotoAndVideos() {
  isDeleting.value = true;

  await PhotoGalleryV2Repo.deleteMyUploadsGroupPhotos(props.customerId, props.fileIdsToDelete, props.currentOperationSource);

  isDeleting.value = false;
}
</script>

<style scoped lang="scss">
// Confirm deletion form ======================================================
.confirm-deletion-modal {
  &__header {
    padding-bottom: 0 !important;
  }
}
</style>
